const talent = {
  addToTag: 'Add to Tag',
  selectTag: 'Target Tag',
  removeFromCurrentTag: 'Remove from current tag',
  transfer: 'Move',
  name: 'Name',
  basicInfo: 'Basic Info',
  profile: 'Personal Profile',
  contact: 'Contact',
  remark: 'Note',
  get: 'Get',
  copySuccess: 'Copied successfully',
  fetchSuccess: 'Fetched successfully',
  fetchFailed: 'Failed to fetch',
  unlockContactWithCost: 'Unlock for {count} contact points',
  insufficientContactPoints: 'Insufficient contact points',
  noUnlockableContact: 'No unlockable contact details',
  expand: 'Expand',
  collapse: 'Collapse',
  talentPoolPageDesc:
    'Select a talent pool to review candidate status, contact details, and batch actions.',
  talentGroups: 'Talent Groups',
  groupRightClickHint: 'Right-click to edit',
  searchGroupPlaceholder: 'Search groups',
  collapseGroupMenu: 'Collapse menu',
  expandGroupMenu: 'Expand menu',
  unselectedBreadcrumb: 'No pool selected',
  unselectedTitle: 'Please select a talent group from the left menu',
  unselectedDesc:
    'Choose All Talents or a talent group from the left to view status overview, filters, and candidates.',
  unselectedHints: {
    aiMatch: 'AI Matching',
    quickFilter: 'Quick Filter',
    batchManage: 'Bulk Actions',
  },
  viewAllTalents: 'View All Talents',
  createGroup: 'New Group',
  apolloImportButton: 'Import Apollo',
  apolloImportTitle: 'Import Apollo Contacts',
  apolloImportUploadTitle: 'Upload Apollo CSV',
  apolloImportUploadDesc:
    'Reads Apollo contact exports and imports only LinkedIn, name, email, and phone. Resume parsing will not run.',
  apolloImportDropTitle: 'Drop CSV or click to choose',
  apolloImportDropDesc: 'Supports Apollo contacts export .csv',
  apolloImportReset: 'Choose again',
  apolloImportTagName: 'Save to tag',
  apolloImportTagPlaceholder: 'Enter a new tag name. Existing tags will be reused.',
  apolloImportTotalRows: 'Total rows',
  apolloImportReadyRows: 'Ready',
  apolloImportSkippedRows: 'Skipped',
  apolloImportPreviewTitle: 'Import Preview',
  apolloImportPreviewDesc:
    'Shows up to the first 50 rows. Rows without LinkedIn or with duplicate LinkedIn URLs are skipped.',
  apolloImportColumnRow: 'Row',
  apolloImportColumnTitle: 'Title',
  apolloImportColumnStatus: 'Status',
  apolloImportStatusReady: 'Ready',
  apolloImportStatusDuplicate: 'Duplicate',
  apolloImportStatusSkipped: 'Skipped',
  apolloImportSubmit: 'Import Contacts',
  apolloImportParsing: 'Parsing...',
  apolloImportProgressReading: 'Reading file',
  apolloImportProgressParsing: 'Parsing CSV',
  apolloImportProgressRows: 'Extracting rows',
  apolloImportProgressNormalizing: 'Normalizing contact fields',
  apolloImportProgressDone: 'Parsing complete',
  apolloImportInvalidFile: 'Please upload a CSV file',
  apolloImportParseFailed: 'Failed to parse CSV. Please check the file format.',
  apolloImportFailed: 'Failed to import contacts. Please try again.',
  apolloImportSuccess: 'Import complete: {created} created, {updated} updated, {skipped} skipped',
  createGroupTitle: 'New Group',
  createGroupHint: 'Organize candidates for later filtering. Name length: 1-64 characters.',
  groupName: 'Group',
  groupNamePlaceholder: 'Enter group name',
  groupNameLengthMessage: 'Group name must be 1-64 characters',
  defaultGroupBadge: 'Default',
  defaultGroupLocked: 'The default talent pool cannot be changed',
  emptyGroups: 'No matching groups',
  loadingGroups: 'Loading groups...',
  loadMoreGroups: 'Load more groups',
  addFriend: 'Connect',
  sendWithoutNote: 'Note, or send without a note',
  confirmDelete: 'Are you sure you want to remove this candidate from the current talent pool?',
  confirmDeleteRemark: 'Delete this note?',
  chinese: 'China-related',
  chinaExperience: 'China Exp.',
  year: ' yrs',
  durationYear: 'y',
  durationMonth: 'mo',
  present: 'Present',
  company: 'Company',
  companyPlaceholder: 'Enter company name',
  phone: 'Phone',
  phonePlaceholder: 'Enter phone number',
  phoneActionsTitle: 'Open WhatsApp Web',
  copyPhone: 'Copy number',
  openWhatsApp: 'Open WhatsApp Web',
  whatsAppOpenNotice: 'This only opens WhatsApp Web. It does not send any message automatically.',
  whatsAppCountryLabel: 'Phone country/region',
  whatsAppTargetPhoneLabel: 'Target Phone Number',
  whatsAppMultiplePhonesCount: '{count} numbers found, select one',
  whatsAppQuickMultipleTitle: 'WhatsApp ({count} phone numbers available)',
  whatsAppPhoneInputPlaceholder: 'Enter or adjust phone number',
  whatsAppPhoneEditHint:
    'Editable for this chat (e.g. remove notes or symbols). Original data remains unchanged.',
  whatsAppCountryPlaceholder: 'Select a country or region',
  whatsAppCountrySearchPlaceholder: 'Search country, region or code (e.g. US, +1)...',
  whatsAppCountryRequired: 'The calling code could not be detected. Select a country first.',
  whatsAppAccessRequired: 'Please contact sales to enable this feature.',
  whatsAppMessageLabel: 'Prefilled message (not sent automatically)',
  whatsAppMessagePlaceholder: 'Enter a message to carry into WhatsApp',
  whatsAppMessageHint:
    'The message stays in the composer until you review and send it in WhatsApp. Clear it to open the chat only.',
  whatsAppDefaultMessage:
    'Hi {name}, I am a recruiter and would like to discuss a job opportunity with you.',
  whatsAppInvalidPhone: 'The phone number is invalid and cannot be opened in WhatsApp',
  email: 'Email',
  emailPlaceholder: 'Enter email',
  namePlaceholder: 'Enter name',
  location: 'Location',
  locationParent: 'Country/Region',
  locationChild: 'Province/State',
  age: 'Age',
  hasChinaExperience: 'Has China company exp.',
  eduLevel: 'Education',
  qsRanking: 'QS Rank',
  majorType: 'Major',
  notePlaceholder: 'Enter note...',
  saveNote: 'Save Note',
  editNote: 'Edit Note',
  deleteNote: 'Delete Note',
  noteList: 'Note List',
  addNote: 'Add Note',
  jobHoppingFrequency: 'Job Stability',
  jobHopping: {
    Max3JobsIn5Years: 'Max 3 Jobs in 5 Years',
    Max2JobsIn3Years: 'Max 2 Jobs in 3 Years',
    Min2YearsInLast2Jobs: 'Min 2 Years in Last 2 Jobs',
    NoLimit: 'No Limit',
  },
  nationality: 'China Fit',
  foreigner: 'Foreign',
  nonChinese: 'Other / Unknown',
  source: {
    manual: 'LinkedIn',
    upload: 'LinkedIn',
    tag_import: 'LinkedIn',
    linkedin: 'LinkedIn',
    automation_import: 'Automation Import',
    talent_recommendation: 'Talent Recommendation',
  },
  // Options
  bachelor: 'Bachelor',
  master: 'Master',
  mba: 'MBA',
  doctorate: 'Doctorate',
  secondary: 'Secondary',
  associate: 'Associate',
  postdoc: 'Postdoc',
  top100: 'Top 100',
  top200: 'Top 200',
  top300: 'Top 300',
  language: 'Language',
  contactMethods: 'Contact Info',
  contactMethodEmail: 'Has Email',
  sendEmail: 'Send Email',
  emailHistory: 'Activity',
  emailHistoryLoading: 'Loading email history...',
  emailHistoryEmpty: 'No email records',
  emailSubjectEmpty: 'No subject',
  emailBodyEmpty: 'No content',
  emailStatus: {
    pending: 'Queued',
    sent: 'Sent',
    goback: 'Bounced',
    failed: 'Failed',
    warning: 'Warning',
  },
  contactMethodPhone: 'Has Phone',
  contactMethodWechat: 'WeChat',
  contactMethodGithub: 'GitHub',
  contactMethodTwitter: 'Twitter',
  contactMethodFacebook: 'Facebook',
  contactMethodInstagram: 'Instagram',
  contactMethodTiktok: 'TikTok',
  contactMethodLinkedin: 'LinkedIn',
  function: 'Function',
  statusFilter: 'Status',
  added: 'Added',
  unsent: 'Not Invited',
  waiting: 'Pending',
  openToWork: 'Open to Work',
  active: 'Active',
  vipRequired: 'Please activate VIP membership.',
  chinaIdentityMembershipRequired: 'Activate membership to view.',
  chineseStatusField: 'whether the candidate is Chinese',
  chinaExperienceStatusField: 'whether the candidate has Chinese-company experience',
  chinaIdentityMembershipLockedTooltip: 'Activate a membership to view {field}.',
  chinaIdentityCreditsLockedTooltip: 'Insufficient AI Credits. Unable to view {field}.',
  vipRequiredForFilter: 'Please activate VIP membership to use filters.',
  linkedinBindRequiredForFilter:
    'Please link a LinkedIn account in Profile before using status filters.',
  greeting: 'Note',
  useTemplate: 'Use Template',
  defaultGreeting: 'Hello {name}, I’m interested in your experience...',
  noEncodedId: 'LinkedIn ID not found for this candidate',
  greetingPlaceholder: 'Add a note...',
  connectTimeout: 'Request timed out, please try again later',
  connectSuccess: 'Sent',
  connectLimitExceeded: 'Daily connection request limit reached',
  connectInviteLimitReached: 'LinkedIn invite limit reached. Try again later or switch accounts.',
  connectInviteLimitReachedForCandidate:
    'Your invitation to {name} was not sent because you have reached LinkedIn’s weekly connection invitation limit. Please try again next week.',
  connectInviteLimitConfirm: 'OK',
  connectInviteLimitViewSent: 'View sent ↗',
  connectFailed: 'Connection request failed: {error}',
  connectAlreadyAddedSyncHint:
    'This candidate is already connected on LinkedIn or the invitation is pending. Please use the one-click sync status button on LinkedIn.',
  linkedinAccountNotLinked:
    'The current LinkedIn account does not match the one linked to your EasyHireAI account. Please switch accounts or relink before continuing.',
  syncLinkedinStatusFailed: 'Failed to sync LinkedIn send status. Please try again later.',
  extensionRequired: 'Please enable the EasyHireAI extension before sending a connection request.',
  extensionStatus: 'Status',
  extensionChecking: 'Checking',
  extensionConnected: 'Connected',
  extensionMissing: 'Not connected',
  extensionRetry: 'Check again',
  extensionHint:
    'Please make sure the EasyHireAI extension is installed and enabled, then refresh the page or reopen this dialog.',
  batchAddFiltered: 'Filtered out {count} candidates already added or pending.',
  batchAddInvalidSelection:
    'Selected candidates are already added or pending and cannot be added in bulk.',
  addFriendNoFsdProfile: 'Candidate lacks a valid LinkedIn fsd_profile identifier',
  batchAddFilteredNoFsdProfile:
    'Filtered {count} candidates lacking valid LinkedIn identifier or already added',
  batchAddInvalidNoFsdProfile:
    'Selected candidates lack valid LinkedIn identifier or have already been added',
  selectCandidatesFirst: 'Please select candidates in the table first.',
  inMailDialogTitle: 'New InMail',
  inMailSelectedSummary: '{count} candidates selected. The same draft will be used.',
  inMailSubject: 'Subject',
  inMailSubjectPlaceholder: 'Enter the InMail subject',
  inMailMessage: 'Message',
  inMailMessagePlaceholder: 'Type your InMail message here...',
  inMailIncomplete: 'Please fill in both subject and message.',
  inMailDraftReady: 'InMail draft generated.',
  aiInMailGoal: 'Goal',
  aiInMailGoalExplore: 'Check Interest',
  aiInMailGoalInterest: 'Schedule a Chat',
  aiInMailGoalForward: 'Request CV',
  aiInMailLanguage: 'Language',
  aiInMailLanguageAuto: 'Auto',
  aiInMailLanguageEnglish: 'English',
  aiInMailLanguageChinese: 'Chinese',
  aiInMailRecruiterRefreshHint:
    'If sending fails, please refresh the page inside a Recruiter project and try again.',
  aiInMailSubject: 'Subject',
  aiInMailGeneratedMessage: 'AI Generated Message',
  aiInMailGenerating: 'Generating',
  aiInMailGeneratingShort: 'Generating',
  aiInMailRegenerate: 'Regenerate',
  aiInMailStartGenerate: 'Generate',
  aiInMailNoCandidateSelected: 'Please select candidates below',
  aiInMailSending: 'Sending InMail...',
  aiInMailSendingTo: 'Sending to {name}',
  aiInMailSendingRemaining: '{count} remaining',
  aiInMailGenerateFailed: 'Failed to generate InMail. Please try again later.',
  aiInMailMembershipRequired: 'Activate a membership to get AI Credits.',
  aiInMailInsufficientCredits: 'Insufficient AI Credits. Recharge or upgrade to continue.',
  aiInMailGenerateFailedShort: 'Failed',
  aiInMailSend: 'Send InMail',
  aiInMailButton: 'AI InMail',
  batchAiInMailButton: 'Bulk AI InMail',
  aiInMailNoTsProfile:
    'This candidate is missing a LinkedIn ts_profile, so InMail is not available yet.',
  aiInMailFilteredNoTsProfile:
    'Automatically filtered out {count} candidates without a LinkedIn ts_profile.',
  aiInMailNoSendableCandidates: 'There are no candidates available for InMail sending.',
  aiInMailSendSuccess: 'InMail sent successfully to {count} candidate(s).',
  aiInMailSendResult: 'InMail results: {success} succeeded, {failed} failed, {unknown} unconfirmed.',
  aiInMailSendFailed: 'Failed to send InMail. Check your LinkedIn login and account permissions.',
  aiInMailSendUnconfirmed: 'Sending is unconfirmed. Check LinkedIn before deciding whether to resend.',
  aiInMailLinkedInRejected: 'LinkedIn returned a business error. Sending failed; check LinkedIn for the specific restriction.',
  aiInMailNoCredits: 'Sending failed: insufficient LinkedIn InMail credits.',
  aiInMailRecipientRestricted: 'Sending failed: this recipient cannot accept InMail.',
  aiInMailDisabledSending: 'InMail is being sent. Please wait.',
  aiInMailDisabledExtension: 'The extension is not connected, so InMail cannot be sent.',
  aiInMailDisabledSubject: 'The InMail subject is missing.',
  aiInMailDisabledMessage: 'The InMail message body is missing.',
  aiInMailDisabledGenerating:
    'InMail is still being generated. Please wait until every selected candidate is ready.',
  aiInMailDisabledDraftsIncomplete:
    'Please generate a complete InMail for every selected candidate before sending.',
  aiInMailDisabledMissingIdentifier:
    '{count} selected candidate(s) are missing a LinkedIn ts_profile, so InMail cannot be sent.',
  aiInMailPreflightFailed: 'Unable to send. Check your membership and the candidate profile.',
  aiInMailSentAt: 'InMail sent: {time} (UTC+8)',
  tagJoinedAt: 'Added to this tag: {time} (UTC+8)',
  aiInMailSentStatusSaveFailed:
    'InMail was sent, but its status could not be saved. Do not send it again.',
  aiInMailSentNote: 'InMail sent. Subject: {subject}',
  aiInMailSentNoteWithResource: 'InMail sent. Subject: {subject}. Conversation: {resourceKey}',
  aiInMailConfigHint:
    'Confirm your InMail settings first so they can be inserted into generated messages.',
  aiInMailGoFill: 'Fill it in',
  aiInMailSignature: 'Signature',
  aiInMailSignaturePlaceholder: 'Enter your signature',
  aiInMailAdditionalInfo: 'Additional info',
  aiInMailAdditionalInfoPlaceholder:
    'Example: location, compensation range, work mode, language requirements, contract terms, willingness to travel, ability to work on-site, ability to communicate in Chinese, any additional information in InMail.',
  aiInMailSaveDefault: 'Save as default',
  aiInMailDefaultConfigLabel: 'InMail settings:',
  aiInMailEditConfig: 'Edit',
  aiInMailEditAdditionalInfo: 'Edit additional info',
  aiInMailEditingHint: 'Editing',
  aiInMailCandidates: 'Candidates',
  aiInMailSelectedCount: '{selected}/{total} selected',
  aiInMailSearchCandidates: 'Search candidates...',
  aiInMailColumnName: 'Name',
  aiInMailColumnCurrentTitle: 'Current Title',
  aiInMailColumnCompany: 'Company',
  aiInMailColumnLocation: 'Location',
  aiInMailColumnPreview: 'Preview',
  aiInMailPreviewButton: 'Preview InMail',
  aiInMailPreviewMessage: 'Preview message',
  aiInMailEmptyCandidates: 'No matching candidates',
  aiInMailSignatureUnset: '--',
  aiInMailBestRegards: 'Best regards,',
  aiInMailFallbackName: 'there',
  batchSendProgress: 'Send progress',
  batchSendProgressSummary: 'Sent {sent}/{total} · Success {success} · Failed {failed}',
  batchSendEta: 'Estimated remaining {eta}',
  batchSendEtaSeconds: '{seconds}s',
  batchSendEtaMinutes: '{minutes}m {seconds}s',
  batchSendEtaHours: '{hours}h {minutes}m',
  batchFetchContact: 'Fetch Contacts',
  batchFetchSelected: 'Fetch Selected',
  batchFetchCurrentJob: 'Fetch Job',
  batchFetchTag: 'Fetch Tag',
  batchFetchType: {
    all: 'Email + Phone',
    phone: 'Phone',
    email: 'Email',
  },
  batchFetchTypedOption: '{scope} · {type}',
  batchFetchNoPermission: 'Your account has no permission to fetch contacts',
  noPermissionReLoginNotice:
    'Your account does not have permission for this action. Please upgrade to Enterprise or contact sales.',
  permissionRefreshed: 'Permission refreshed. Please proceed.',
  batchFetchNoSelection: 'Please select candidates first',
  batchFetchDialogTitle: 'Fetch Contacts',
  batchFetchModeSelected: 'Selected Rows',
  batchFetchModeCurrentJob: 'Current Job',
  batchFetchModeTag: 'Entire Tag',
  batchFetchPreparing: 'Calculating fetchable candidates...',
  batchFetchPlanSummary: '{fetchable} of {total} candidates can be fetched (est. {points} credits)',
  batchFetchAlreadyHas: 'Skipped {count} candidates (already have the requested contact)',
  batchFetchInsufficient: 'Filtered {count} candidates due to insufficient credits',
  batchFetchNeedPoints: 'Current credits: {points}',
  batchFetchEmpty: 'No candidates need contact fetch',
  batchFetchConfirm: 'Start Fetch',
  batchFetchRunning: 'Fetching contacts...',
  batchFetchResult: 'Contact fetch: {success} found, {failed} unavailable',
  batchFetchCurrentJobLoadingFailed: 'Failed to load candidates in the current job. Please retry.',
  batchFetchTagLoadingFailed: 'Failed to load tag candidates. Please retry.',
  batchFetchApolloEmail: 'Fetch Emails',
  batchFetchApolloEmailNoSelection: 'Please select candidates to fetch emails',
  batchFetchApolloEmailEmpty: 'All selected candidates already have emails',
  batchFetchApolloEmailRunning: 'Fetching emails from Apollo...',
  batchFetchApolloEmailResult:
    'Apollo email fetch: {success} found, {skipped} skipped, {failed} unavailable',
  batchFetchApolloEmailFailed: 'Failed to fetch emails from Apollo. Please try again later.',
  batchFetchProviderEmail: 'Fetch Emails',
  batchFetchProviderEmailRunning: 'Fetching emails from {provider}...',
  batchFetchProviderEmailResult:
    '{provider} email fetch: {success} found, {skipped} skipped, {failed} unavailable',
  batchFetchProviderEmailFailed: 'Failed to fetch emails from {provider}. Please try again later.',
  contactProviderApollo: 'Apollo',
  contactProviderContactout: 'AI Search',
  contactProviderLeadContact: 'LeadContact',
  batchSendEmail: 'Send Emails',
  oneClickBatchSendEmail: 'Send Emails',
  batchEmailNoData: 'No candidates on this page to email',
  batchEmailSelectedNoEmail: 'None of the selected candidates has a usable email address',
  batchEmailConfig: 'Sender',
  batchEmailMode: 'Mode',
  batchEmailModeTemplate: 'Template',
  batchEmailModeCustom: 'Custom',
  batchEmailPreview: 'Preview Email',
  batchEmailPreviewRecipients: 'Recipients',
  batchEmailPreviewMode: 'Mode',
  batchEmailPreviewModeTemplate: 'Template',
  batchEmailPreviewModeCustom: 'Custom',
  batchEmailTemplate: 'Email Message',
  batchEmailSubject: 'Subject',
  batchEmailSubjectPlaceholder: 'Enter email subject',
  batchEmailBody: 'Body',
  batchEmailBodyPlaceholder: '<p>Hello, we have a role that may interest you.</p>',
  batchEmailSelectConfig: 'Please select an email config',
  batchEmailSelectTemplate: 'Please select a template',
  batchEmailIncomplete: 'Please fill in both subject and body',
  batchEmailFiltered: 'Automatically filtered {count} candidates without email',
  batchEmailSubmitted: 'Batch email request submitted',
  batchEmailLoadFailed: 'Failed to load email resources. Please try again.',
  batchEmailSendFailed: 'Batch email sending failed. Please try again.',
  batchEmailProgressMeta:
    'Success {success} / Failed {failure} / Pending {pending} / Warning {warning}',
  batchEmailResultMixed:
    'Email sending finished: {success} succeeded, {failure} failed, {warning} warnings',
  batchEmailResultWarning: 'Email sending finished: {success} succeeded, {warning} warnings',
  batchEmailResultPanelTitle: 'Send results',
  batchEmailResultSummary: 'Success {success}, Failed {failure}, Warning {warning}',
  batchEmailResultSuccess: 'Success',
  batchEmailResultFailure: 'Failed',
  batchEmailResultWarningCount: 'Warning',
  batchEmailResultStatusSent: 'Sent',
  batchEmailResultStatusFailed: 'Failed',
  batchEmailResultStatusWarning: 'Warning',
  batchEmailResultFilterAll: 'All',
  batchEmailResultFilterFailed: 'Failed only',
  batchEmailResultFilterSent: 'Success only',
  batchEmailResultFilterWarning: 'Warnings only',
  batchEmailResultExportFailed: 'Export failed list',
  batchEmailResultRetryFailed: 'Retry failed recipients',
  batchEmailResultColumnCandidate: 'Candidate',
  batchEmailResultColumnEmail: 'Email',
  batchEmailResultColumnStatus: 'Status',
  batchEmailResultColumnReason: 'Result details',
  batchEmailResultEmpty: 'No results match the current filter',
  batchEmailResultFooterTip:
    'After sending, you can filter results, export the failed list, or retry failed recipients.',
  batchEmailRetryingFailed: 'Retrying failed recipients...',
  batchEmailRetryFailed: 'Retrying failed recipients failed. Please try again later.',
  batchEmailConfigPanelTitle: 'Sending configuration',
  batchEmailConfigPanelDesc: 'Choose the sender config, mode, and message content.',
  batchEmailTargetsTitle: 'Candidate preview',
  batchEmailTargetsDesc: '{count} candidates will receive this email batch.',
  emailNoConfig: 'Email config not bound. Redirecting to email settings...',
  emailLoadPreviewFailed: 'Failed to load email preview',
  emailLoadHistoryFailed: 'Failed to load email history',
  emailSelectConfig: 'Please select an email config',
  emailSelectTemplate: 'Please select an email template',
  emailSelectSenderConfig: 'Please select a sender config',
  emailAddConfig: '+ Add Sender',
  emailUnnamedConfig: 'Unnamed Config',
  emailUnnamedTemplate: 'Unnamed Template',
  emailCandidateLabel: 'Candidate',
  emailRecipientLabel: 'Recipient',
  emailRecipientMissing: 'No available recipient email',
  emailPlaceholderLabel: 'Placeholders:',
  emailPlaceholderExample: "eg: Hello {'{{name}}'} = Hello Clement Hu",
  emailSaveTemplate: 'Save Template',
  emailPreviewLoading: 'Previewing...',
  emailPreviewEmptySubject: 'No email subject',
  emailPreviewEmptyBody: 'No email content',
  emailPreparingSend: 'Preparing to send...',
  emailPrepareFullContent: 'Please prepare a complete email subject and body first',
  emailSent: 'Email sent',
  emailSendFailed: 'Send failed',
  emailSendProgressDefault: 'AI is processing the email',
  emailTemplateSaved: 'Template saved',
  emailTemplateSaveFailed: 'Failed to save template',
  emailCandidateInvalid: 'Invalid candidate ID. Unable to send email',
  emailPreview: 'Email Preview',
  batchEmailProgressDefault: 'AI is processing',
  batchEmailStageConfig: 'Load config',
  batchEmailStageParse: 'Parse content',
  batchEmailStageCandidates: 'Confirm candidates',
  batchEmailStageCompose: 'Compose email',
  batchEmailStageSend: 'Send email',
  batchEmailStageSummary: 'Summarize',
  gmailDirectConfigLabel: 'Connected Gmail (Beta)',
  gmailDirectSending: 'Sending directly through the connected Gmail account...',
  gmailDirectSent: 'Gmail sent successfully',
  gmailDirectSenderMissing: 'No usable Gmail sender address is available for the current account',
  exportExcel: 'Export Excel',
  exportCurrentPage: 'Export Page',
  exportCurrentJobAll: 'Export All in Current Job',
  exportAll: 'Export All',
  exportFiltered: 'Export Filtered',
  exportSelected: 'Export Selected',
  exportNoData: 'No candidates available to export',
  exportNoSelection: 'Please select candidates to export first',
  exportFailed: 'Export failed. Please try again.',
  exportProgressTitle: 'Exporting',
  exportProgressKicker: 'Export Task',
  exportProgressAiKicker: 'AI Export',
  exportProgressHint: 'Please wait while the system prepares your export file.',
  exportProgressAiAllHint: 'AI is organizing candidate data from the current tag.',
  exportProgressAiFilterHint: 'AI is organizing the current filtered result set.',
  exportProgressAiJobHint: 'AI is organizing candidate data from the current job.',
  exportProgressPermission: 'Checking export permission...',
  exportProgressPrepare: 'Preparing export data...',
  exportProgressTag: 'Collecting data from the current tag...',
  exportProgressFilter: 'Preparing the current filtered result set...',
  exportProgressCollect: 'Continuing to organize export content...',
  exportProgressBuild: 'Building Excel workbook...',
  exportProgressRows: 'Writing worksheet rows...',
  exportProgressFile: 'Packaging export file...',
  exportProgressDownload: 'Starting browser download...',
  exportProgressDone: 'Export completed',
  exportCurrentPageSuccess: 'Current page exported: {count} candidates',
  exportCurrentJobAllSuccess: 'All candidates in the current job exported: {count} candidates',
  exportAllSuccess: 'All candidates exported: {count} candidates',
  exportFilteredSuccess: 'Filtered results exported: {count} candidates',
  exportSelectedSuccess: 'Selected candidates exported: {count} candidates',
  batchAddToJob: 'Add to Job',
  batchAddToJobTitle: 'Add to Job',
  batchAddToJobSelectJob: 'Select target job',
  batchAddToJobPlaceholder: 'Please select a job',
  batchAddToJobConfirm: 'Confirm',
  batchAddToJobRunning: 'Adding candidates to job...',
  batchAddToJobResult: 'Batch add completed: {success} succeeded, {failed} failed',
  batchAddToJobNoSelection: 'Please select a job first',
  batchRemoveFromJob: 'Remove from Job',
  batchRemoveFromJobDialogTitle: 'Remove Candidates from Job',
  batchRemoveFromJobConfirm:
    'Are you sure you want to remove these candidates from the current job?',
  batchRemoveFromJobResult: 'Batch remove completed: {success} succeeded, {failed} failed',
  batchRemoveFromJobFailed: 'Failed to remove candidates from the current job. Please try again.',
  exportSheetTitle: 'EasyHireAI Talent Export Report',
  exportTagLabel: 'Tag',
  exportByLabel: 'Exported by',
  exportGeneratedAt: 'Generated at',
  exportSummaryTitle: 'EasyHireAI Talent Export Overview',
  exportSummarySheetName: 'Overview',
  exportSummaryTotalCandidates: 'Total Candidates',
  exportSummaryLocationTypes: 'Location Count',
  exportSummaryCompanyTypes: 'Company Count',
  exportSummarySalesShareTitle: 'Sales Talent Share',
  exportSummaryLevelShareTitle: 'Match Level Distribution',
  exportSummaryLocationShareTitle: 'Location Talent Share',
  exportSummaryCompanyShareTitle: 'Company Talent Share',
  exportSummaryLabel: 'Dimension',
  exportSummaryCount: 'Count',
  exportSummaryShare: 'Share',
  exportSummarySalesLabel: 'Sales-related',
  exportSummaryNonSalesLabel: 'Non-sales',
  exportSummaryUnknownRoleLabel: 'Unknown role',
  exportSummaryOthers: 'Others',
  exportSummaryUnknown: 'Unknown',
  exportSheetName: 'Talent Report',
  exportAge: 'Age',
  exportCurrentRole: 'Current Role',
  exportOpenToWork: 'Open to Work',
  exportActiveStatus: 'Active Status',
  exportFriendStatus: 'Conn. Status',
  exportLatestCompany: 'Latest Company',
  exportCombinedExperience: 'Experience & Education',
  exportUnknown: 'Unknown',
  exportDurationYear: '{count}y',
  exportDurationMonth: '{count}mo',
  workYears: 'Work Years',
  latestExperience: 'Experience',
  latestEducation: 'Education',
  exportAnalysisScore: 'Match Score',
  exportAnalysisLevel: 'Match Level',
  exportAnalysisStrengths: 'Match Strengths',
  exportAnalysisRisks: 'Match Risks',
  exportAnalysisRecencyInsight: 'Recent Insight',
  exportAnalysisDetail: 'Match Analysis Detail',
  emptyGuideTitle: 'Your talent pool is currently empty',
  emptyGuideDesc:
    'Please use the EasyHireAI sidebar on LinkedIn, or use AI talent parsing on LinkedIn search pages / bind from LinkedIn profile pages, then return to the talent pool.',
  templateManagement: 'Note Templates',
  inMailTemplateManagement: 'InMail Template Management',
  addTemplate: 'Add Template',
  templateEmptyTitle: 'No greeting templates yet',
  templateEmptyDesc: 'Add reusable greeting content for quick selection when sending.',
  editTemplate: 'Edit Template',
  selectTemplate: 'Select',
  previewTemplate: 'Preview',
  templatePreview: 'Template Preview',
  templateTitle: 'Template Title',
  templateContent: 'Template Content',
  templateTitlePlaceholder: 'Enter template title (e.g., General note)',
  templateContentPlaceholder: 'Enter template content',
  inMailTemplateTitlePlaceholder: 'Enter template title (e.g., First Outreach)',
  inMailTemplateContentPlaceholder: 'Enter the InMail template content',
  templateContentTooLong: 'Template content cannot exceed {count} characters',
  confirmDeleteTemplate: 'Are you sure you want to delete this template?',
  matchScore: 'Match {score}%',
  expandSearchFilters: 'Expand search filters',
  collapseSearchFilters: 'Collapse search filters',
  dateYearMonth: '{month} {year}',
  summary: {
    profileTab: 'Profile',
    pipelineTab: 'Pipeline & Activity',
    detailTitle: 'Candidate Details',
    tabSummary: 'AI Summary',
    tabEducation: 'Education',
    tabExperience: 'Experience',
    aiSummaryTitle: 'AI Summary',
    aiKicker: 'AI evaluation',
    experienceKicker: 'Career history',
    educationKicker: 'Academic background',
    rating: 'RATING',
    resume: 'Resume',
    coreInsight: 'Core insight',
    matchStrengths: 'Strengths',
    riskSignals: 'Risk signals',
    addComment: 'Add feedback',
    activityLog: 'Activity',
    pipelineTitle: 'Project / Pipeline',
    projectTitle: 'Project',
    inProgress: 'In progress',
    rollbackToStage: 'Roll back to stage',
    moveStageMenuTitle: 'Move to stage',
    pipelineFallback: 'Current role',
    moveToStage: 'Move to next stage: {stage}',
    reachOut: 'Reject',
    stageSubmitted: 'Screening',
    stageScreening: 'Outreach / Engaging',
    stageRecommended: 'Submitted / Recommended',
    stageInterview: 'Interviewing',
    stageOffer: 'Offer Negotiation',
    stageOnboard: 'Offer Accepted / Pre-onboarding',
    stageArrived: 'Hired / Onboarded',
    rejectScreening: 'Rejected at screening',
    rejectInterview: 'Rejected after interview',
    rejectSalaryMismatch: 'Salary mismatch',
    rejectOfferDeclined: 'Offer declined',
    noteAdded: 'Added a new candidate note',
    statusChanged: 'Stage updated to "{status}"',
    systemGenerated: 'System',
    profileViewed: 'Opened the candidate detail drawer',
    timeUnknown: 'Unknown time',
    emptyRemark: 'No notes yet.',
    emptyRole: 'Role not provided',
    locationUnknown: 'Location pending',
    contactUnknown: 'Pending',
    functionUnknown: 'Function pending',
    educationUnknown: 'Education not provided',
    jobMatchTitle: 'Job Match Analysis',
    aiScore: 'AI Score {score}',
    skillAnalysisTitle: 'Skill Analysis',
    skillTags: 'Skill Tags',
    emptyEducation: 'No education records',
    emptyExperience: 'No work records',
    mockNoData: 'No structured analysis available. MOCK content is shown.',
    mockWorkYears: 'Estimated work experience: {years} years.',
    mockLatestCompany: 'Most recent company: {company}.',
    mockLatestRole: 'Most recent role direction: {title}.',
    mockLocation: 'Current location: {location}.',
    strengthSkills: 'The skill stack covers {skills} and aligns well with the current profile.',
    strengthYears: 'Roughly {years} years of relevant experience support more complex ownership.',
    strengthExperienceDepth:
      '{count} structured experience records provide solid career continuity.',
    strengthChinaExperience:
      'Has China company exp. and can support localized collaboration needs.',
    strengthLanguages:
      'Language coverage includes {languages}, which helps cross-region collaboration.',
    defaultStrength:
      'The candidate profile is reasonably complete and ready for interview validation.',
    riskNoSummary:
      'The resume summary is light. Validate project depth and scope in follow-up conversations.',
    riskNoDirectContact:
      'Direct contact information is missing, so progress may depend on platform outreach.',
    riskLimitedExperience:
      'Structured work history is limited. Cross-check the full career path with the resume.',
    riskWorkStatusUnknown: 'Current job-search intent is unclear and should be confirmed early.',
    riskBusinessGap:
      'There may be a gap between prior experience and the current business context. Validate real execution cases in follow-up interviews.',
    candidateFallback: 'This candidate',
    analysisFallback:
      '{name} shows relevant experience for the target role. The latest focus is {role} work, with most output tied to {company}. Follow-up discussion should validate project depth, team size, and real ownership.',
    uploadedNewResume: 'Uploaded a new resume',
    oneDayAgo: '1d ago',
    fiveDaysAgo: '5d ago',
    interviewInvitationRoundTwo: 'Interview invitation - round two',
    yesterdayAt: 'Yesterday 14:30',
    interviewInvitationPreview:
      'Congrats on passing the first round. We would like to invite you to the second technical interview...',
    sentByName: 'Sent by {name}',
    resumeScreeningPassed: 'Resume screening passed',
    threeDaysAgo: '3d ago',
    resumeScreeningPreview:
      'Thank you for applying to the senior frontend engineer role. Your resume has passed initial screening...',
    sentAutomatically: 'Sent automatically',
    defaultStack: 'frontend engineering, collaboration, and delivery execution',
    experienceFallback: 'Handled {title} work at {company}, covering areas such as {stack}.',
    fallbackTag1: 'Sales',
    fallbackTag2: 'Overseas Expansion',
    fallbackTag3: 'Client Development',
    recommendationReport: 'Recommendation Report',
    recommendationReportExporting: 'Exporting...',
    recommendationReportNotAvailable:
      'Failed to export the recommendation report. Please try again.',
    assessmentReportNotAvailable: 'Not yet available, stay tuned.',
    reportTitle: 'AI Recommendation Report',
    reportSubtitle: 'Position: {job}',
    generatedBy: 'Generated by EasyHire AI',
    reportName: 'Candidate Recommendation Report',
    reportBasicInfo: 'Basic Info',
    reportJobInfo: 'Job Info',
    reportDomain: 'Domain',
    reportExperienceSummary: 'Experience Summary',
    reportPosition: 'Position',
    reportTime: 'Time',
    reportSchool: 'School',
    reportEducationMajor: 'Degree / Major',
    scoreUnrated: 'Unrated',
    scoreStrongRecommend: 'Strong',
    scoreRecommend: 'Recommend',
    scoreAdvance: 'Advance',
    scoreBackup: 'Backup',
    scoreCautious: 'Cautious',
    scoreNotRecommend: 'No',
    candidateInfo: 'Candidate Info',
    candidateName: 'Name',
    currentRole: 'Current Role',
    aiRating: 'AI Analysis Score',
    recencyInsight: 'Recency Insight',
    workYearsLabel: 'Work Years',
    workYearsUnknown: 'Work years pending',
    reportFooterTitle: 'EasyHire AI Candidate Recommendation Report',
    reportFooterSubtitle: 'Generated from existing structured data',
  },
}

export default talent
